import { Injectable } from '@angular/core';
import { UserToken, Account } from '../models';
import { NativeChannelService } from './native-channel.service';
import { LocalStorageService } from './local-storage.service';
import 'rxjs/Rx';


@Injectable()
export class AccountsService {
  Accounts_KEY: string = 'nova_accounts';

  constructor(
          private _localStorageService: LocalStorageService,
          private _nativeChannelService: NativeChannelService
      ) {}

  getAccounts(): Account[] {
      let accountsFromStorage = this._localStorageService.get(this.Accounts_KEY) || [];
      return accountsFromStorage.map(a => new Account(a));
  }

  getAccountByUser(user: UserToken): Account {
        if (!user) {
             return;
         }
        return this.getAccountByName(user.accountName);
  }

  getAccountByName(accountName: string): Account {
        if (!accountName) {
            return;
        }

        let accounts = this.getAccounts();
        let account = accounts.find(a => this.accountsEquals(accountName, a.accountName));
        if (account) {
            return new Account(account);
        }
  }

  updateAccounts(accountToUpdate: Account) {
     if (!accountToUpdate || !accountToUpdate.accountName) {
         return;
     }

     let accounts = this.getAccounts();
     let account = this.getAccountByName(accountToUpdate.accountName);

    //If account already exist remove it from local  storage and device token then add it again with new information
    if (account) {
         this._removeDeviceToken(account.access_token);

          if (accountToUpdate.access_token) {
              this._nativeChannelService.setUserToken(accountToUpdate.access_token);
          }

          accounts = accounts.filter(a => !this.accountsEquals(accountToUpdate.accountName, a.accountName));
    }

    accountToUpdate.accountName = this._formatAccount(accountToUpdate.accountName);
    accounts.push(accountToUpdate);
    this._localStorageService.set(this.Accounts_KEY, accounts);
  }

  removeAccount(accountName: string) {
          let account = this.getAccountByName(accountName);

          if (account) {
                //remove device token
                this._nativeChannelService.setUserToken(account.access_token);
                this._nativeChannelService.logoff();

                //remove account from local storage
                let accounts = this.getAccounts();
                accounts = accounts.filter(a => !this.accountsEquals(accountName, a.accountName));
                this._localStorageService.set(this.Accounts_KEY, accounts);
          }
  }

  accountsEquals(account1: string, account2: string): boolean {
        if (!account1 || !account2) {
            return false;
        }

        account1 = this._formatAccount(account1);
        account2 = this._formatAccount(account2);

        return account1 === account2;
  }

  removeUserTokenFromAccount(account: Account) {
        if (!account) {
            return;
        }

        // Remove token from account to sign out
        account['access_token'] = null;
        this.updateAccounts(account);
  }

  private _formatAccount(account: string) {
       if (!account) {
            return;
        }

        return account.replace(/_/g, '-').toUpperCase();
  }

  private _removeDeviceToken(token: string) {
        if (!token) {
            return;
        }
       this._nativeChannelService.setUserToken(token);
       this._nativeChannelService.logoff();
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/services/accounts.service.ts